import { getQaSelector } from '../../../../../../utils/common'
import { Skeleton } from '../../../../../Skeleton'
import {
  APPLICANT_BOARD_SKELETON_CARDS,
  QA_NAME_APPLICANT_BOARD_SKELETON_CARD,
} from '../../../RentalPortalApplicants.constants'

import * as styles from './RentalPortalApplicantsBoardColumnSkeleton.module.css'

function RentalPortalApplicantsBoardColumnSkeleton() {
  return APPLICANT_BOARD_SKELETON_CARDS.map(skeletonCard => (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_BOARD_SKELETON_CARD })}
      className={styles.RentalPortalApplicantsBoardColumnSkeleton}
      key={skeletonCard}
    >
      <Skeleton className={styles.title} />
      <Skeleton className={styles.meta} />
    </div>
  ))
}

export default RentalPortalApplicantsBoardColumnSkeleton
